export const seoConfig = {
  title: "maaboom | ซื้อสินค้าและบริการสัตว์เลี้ยงออนไลน์",
  titleTemplate: "%s",
  defaultTitle: "maaboom",
  description:
    "ซื้ออาหารสุนัข อาหารแมว อุปกรณ์ ของใช้สัตว์เลี้ยง โรงแรมสัตว์เลี้ยง ฝากเลี้ยง สัตวแพทย์ ครบจบในที่เดียว maaboom สั่งง่าย ส่งไว ราคาคุ้ม",
  canonical: "https://www.maaboom.com/",
  openGraph: {
    type: "website",
    locale: "th_TH",
    url: "https://www.maaboom.com/",
    site_name: "maaboom",
    title:
      "maaboom | ซื้อสินค้าและบริการสัตว์เลี้ยงออนไลน์ ศูนย์รวมร้านค้าสำหรับสัตว์เลี้ยงที่น่ารักของคุณ",
    description:
      "ซื้ออาหารสุนัข อาหารแมว อุปกรณ์ ของใช้สัตว์เลี้ยง โรงแรมสัตว์เลี้ยง ฝากเลี้ยง สัตวแพทย์ ครบจบในที่เดียว maaboom สั่งง่าย ส่งไว ราคาคุ้ม",
    images: [
      {
        url: "https://cdn.maaboom.com/web/fb_share.png",
        width: 1200,
        height: 630,
        alt: "maaboom - ซื้อสินค้าและบริการสัตว์เลี้ยงออนไลน์ ศูนย์รวมร้านค้าสำหรับสัตว์เลี้ยงที่น่ารักของคุณ",
        type: "image/png",
        secureUrl: "https://cdn.maaboom.com/web/fb_share.png",
      },
    ],
  },
  robots: {
    isProduction: {
      name: "robots",
      content: "index, follow",
    },
    isNotProduction: {
      name: "robots",
      content:
        "noindex, nofollow, noarchive, nosnippet, notranslate, noimageindex",
    },
  },
  additionalMetaTags: [
    { property: "color-scheme", content: "light only" },
    {
      name: "keywords",
      content:
        "ซื้ออาหารสุนัขออนไลน์, ซื้ออาหารแมวออนไลน์, อาหารสัตว์เลี้ยงราคาถูก, อุปกรณ์สัตว์เลี้ยง, ของเล่นสัตว์เลี้ยง, ทรายแมว, โรงแรมสัตว์เลี้ยง, ฝากเลี้ยงสัตว์เลี้ยง, โรงพยาบาลสัตว์, maaboom",
    },
    { httpEquiv: "x-ua-compatible", content: "IE=edge; chrome=1" },
    {
      name: "twitter:title",
      content:
        "maaboom | ซื้อสินค้าและบริการสัตว์เลี้ยงออนไลน์ ศูนย์รวมร้านค้าสำหรับสัตว์เลี้ยงที่น่ารักของคุณ",
    },
    {
      name: "twitter:description",
      content:
        "ซื้ออาหารสุนัข อาหารแมว อุปกรณ์สัตว์เลี้ยง ครบจบในที่เดียว maaboom – ช้อปสะดวก ส่งไว ราคาคุ้ม",
    },
    {
      name: "twitter:image",
      content: "https://cdn.maaboom.com/web/fb_share.png",
    },
    { name: "theme-color", content: "#DB5A00" },
  ],
  twitter: {
    handle: "@maaboom",
    site: "@maaboom",
    cardType: "summary_large_image",
  },
  facebook: {
    appId: "1107205800174708",
  },
  socialLinks: [
    "https://www.facebook.com/maaboom.official",
    "https://www.instagram.com/maaboom.official/",
    "https://www.youtube.com/@maaboom-club",
    "https://www.tiktok.com/@maaboom",
    "https://play.google.com/store/apps/details?id=com.petsploy360innovative.petsploy",
    "https://apps.apple.com/th/app/maaboom/id1662787944",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress:
      "111/1, Building 111 Praditmanutham, Unit B210, Praditmanutham Rd, Ladprao",
    addressLocality: "Bangkok",
    addressCountry: "TH",
    addressRegion: "Thailand",
    postalCode: "10230",
  },
  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "maaboom",
      url: "https://www.maaboom.com",
      logo: {
        "@type": "ImageObject",
        url: "https://cdn.maaboom.com/web/fb_share.png",
        width: 1200,
        height: 630,
      },
      sameAs: [
        "https://www.facebook.com/maaboom.official",
        "https://www.instagram.com/maaboom.official/",
        "https://www.youtube.com/@maaboom-club",
        "https://www.tiktok.com/@maaboom",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "111/1, Building 111 Praditmanutham, Unit B210, Praditmanutham Rd, Ladprao",
        addressLocality: "Bangkok",
        addressCountry: "TH",
        addressRegion: "Thailand",
        postalCode: "10230",
      },
    },
    website: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      url: "https://www.maaboom.com",
      name: "maaboom",
      potentialAction: {
        "@type": "SearchAction",
        target:
          "https://www.maaboom.com/search/allsearch?keyword={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    onlineStore: {
      "@context": "https://schema.org",
      "@type": "OnlineStore",
      url: "https://www.maaboom.com",
      name: "maaboom",
      description:
        "ซื้อสินค้าและบริการสัตว์เลี้ยงออนไลน์ อาหารสุนัข อาหารแมว อุปกรณ์สัตว์เลี้ยง ครบจบที่เดียว",
      logo: {
        "@type": "ImageObject",
        url: "https://cdn.maaboom.com/web/logos.webp",
      },
      sameAs: [
        "https://www.facebook.com/maaboom.official",
        "https://www.instagram.com/maaboom.official/",
        "https://www.youtube.com/@maaboom-club",
        "https://www.tiktok.com/@maaboom",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "111/1, Building 111 Praditmanutham, Unit B210, Praditmanutham Rd, Ladprao",
        addressLocality: "Bangkok",
        addressCountry: "TH",
        addressRegion: "Thailand",
        postalCode: "10230",
      },
    },
  },
};
